import request from '@teetsh/app/src/utils/request';
import { useMutation } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

interface Props {
  ficheDePrepId: string;
}

function copyToCMSFicheDePrep({ ficheDePrepId }: Props) {
  const url = `${
    import.meta.env.VITE_API_URL
  }/fiches-de-prep/${ficheDePrepId}/copy-to-cms`;

  return request(url, {
    method: 'POST',
  });
}

export function useSendToCMSFicheDePrep() {
  const { notifyError, notifySuccess } = useNotification();
  const { t } = useTranslation(['sequence', 'common']);

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: ({ ficheDePrepId }: { ficheDePrepId: string }) =>
      copyToCMSFicheDePrep({ ficheDePrepId }),

    onSuccess: () => {
      notifySuccess({
        title: t('sequence:messages.fdp.sendToCMSSuccess'),
      });
    },
    onError: () => {
      notifyError({
        title: t('common:messages.genericError'),
      });
    },
  });

  return { sendToCMS: mutateAsync, isLoading };
}
